export const MAX_PRODUCTS_HPPush1Produit = 10;
export const MAX_PRODUCTS_HPPush2Produit = 10;
export const MAX_PRODUCTS_PopinAjoutProduit = 10;
export const MAX_PRODUCTS_SearchNoResultDecouvrezAussiProduit = 10;
export const MAX_PRODUCTS_SearchNoResultVousAimerezProduit = 10;
